/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListTicketStatus } from '../../models/api-response-list-ticket-status';

export interface GetAllStatus1$Params {
}

export function getAllStatus1(http: HttpClient, rootUrl: string, params?: GetAllStatus1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTicketStatus>> {
  const rb = new RequestBuilder(rootUrl, getAllStatus1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListTicketStatus>;
    })
  );
}

getAllStatus1.PATH = '/v1/api/admin-ui/status-ticket/all';
